module.exports = __webpack_public_path__ + "img/img16.45ae9c01.jpg";